<pr-form
  (onSubmit)="submit()"
  [title]="title"
  [formGroup]="form"
  prLoader
  [loading]="loading"
  clazz="drawer-form"
  submitLabel="Confirmer la renonciation"
>
  <button top-right-action class="btn-nostyle" type="button">
    <pr-icon
      name="sp-close"
      viewBoxHeight="23"
      viewBoxWidth="23"
      (click)="onCancel()"
    ></pr-icon>
  </button>

  <h3 class="drawer-title no-paddingtop">Informations</h3>

  <div class="form-sct-container">
    <pr-input label="Nom" [derrors]="derrors">
      <input formControlName="lastName" type="text" />
    </pr-input>

    <pr-input label="Prénom" [derrors]="derrors">
      <input formControlName="firstName" type="text" />
    </pr-input>

    <pr-input label="Numéro du contrat" [derrors]="derrors">
      <input formControlName="contractNumber" type="text" />
    </pr-input>

    <pr-input label="Mode accusé de réception" [derrors]="derrors">
      <mat-select formControlName="renunciationMethod">
        @for (method of renunciationMethods; track method.id) {
          <mat-option [value]="method.id">
            {{ method.label }}
          </mat-option>
        }
      </mat-select>
    </pr-input>
  </div>

  <h3 class="drawer-title">Motif de la renonciation</h3>

  <div class="form-sct-container">
    <div class="reason-field">
      <pr-input [derrors]="derrors">
        <textarea
          formControlName="reason"
          rows="4"
          maxlength="200"
          placeholder="Commencez à écrire ici ..."
        ></textarea>
      </pr-input>
      <span class="char-counter">{{ reasonLength }}/200</span>
    </div>
  </div>
</pr-form>
